import { Dialog, DialogContent, DialogActions, Button, Typography } from '@vapor/material'
import { useTranslation } from 'react-i18next'
import useBreakpoints from 'src/app/hooks/breakpoints/use-breakpoints'

type UnsavedChangesDialogProps = {
  open: boolean
  handleCloseDialog: () => void
  onCloseAndDiscard: () => void
}
export default function UnsavedChangesDialog(props: UnsavedChangesDialogProps) {
  const { t } = useTranslation()
  const { open, handleCloseDialog, onCloseAndDiscard } = props
  const { sm } = useBreakpoints()
  return (
    <Dialog open={open} onClose={handleCloseDialog}>
      <DialogContent>
        <Typography variant="titleSmall">{t('commons.unsaved_changes')}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          size={!sm ? 'small' : undefined}
          variant="outlined"
          color={'error'}
          onClick={onCloseAndDiscard}
          sx={{
            backgroundColor: 'white',
          }}
        >
          {t('commons.close_and_discard_changes')}
        </Button>
        <Button
          size={!sm ? 'small' : undefined}
          variant="contained"
          onClick={handleCloseDialog}
        >
          {t('commons.stay_here')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
